import { render, staticRenderFns } from "./ChannelControls.vue?vue&type=template&id=586ad7be&scoped=true&"
import script from "./ChannelControls.vue?vue&type=script&lang=ts&"
export * from "./ChannelControls.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelControls.vue?vue&type=style&index=0&id=586ad7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586ad7be",
  null
  
)

export default component.exports